import { FormatFunction } from '../types';

import { Mask } from '.';

export class AlphanumericMask extends Mask {
  constructor(mask: string, maxLength?: number) {
    super(mask, maxLength);
    this.maxLength =
      maxLength && maxLength >= mask.length + 1 ? maxLength : mask.length + 1;
  }

  private isAMaskChar = (char: string): boolean => {
    return char === '#' || char === '%' || char === '!';
  };

  private isNumber = (char: string): boolean => /[0-9]/.test(char);

  private isLetter = (char: string): boolean => /[a-z]/i.test(char);

  private getCursorStart = (
    maskedValue: string,
    previousValue: string,
    currentPosition: number,
  ): number => {
    const onlyMaskNew = maskedValue.replace(/[0-9a-zA-Z]/g, '');
    const onlyMaskOld = previousValue.replace(/[0-9a-zA-Z]/g, '');
    let cursorPosition =
      currentPosition + (onlyMaskNew.length - onlyMaskOld.length);

    let cursorAtMask = true;

    while (cursorAtMask) {
      const maskChar = this.mask[cursorPosition - 1] as string;

      if (this.isAMaskChar(maskChar) || cursorPosition >= this.mask.length) {
        cursorAtMask = false;
      } else {
        cursorPosition += 1;
      }
    }

    return cursorPosition;
  };

  unformat = (formattedValue: string) => {
    let rawValue = '';

    formattedValue.split('').forEach((valueChar: string, index: number) => {
      const maskChar = this.mask[index] as string;

      if (this.isAMaskChar(maskChar)) {
        rawValue += valueChar;
      } else {
        rawValue += '';
      }
    });

    return rawValue;
  };

  format: FormatFunction = (value, { previousValue, selectionStart }) => {
    let maskedValue = '';
    let valueIndex = 0;
    let hasInvalidValue = false;
    const rawValue = value.replace(/[^0-9a-zA-Z]/g, '');
    const isDeleting = previousValue.length > value.length;

    this.mask.split('').forEach((maskChar: string) => {
      if (hasInvalidValue) return;

      if (
        valueIndex >= rawValue.length &&
        (this.isAMaskChar(maskChar) || isDeleting)
      ) {
        hasInvalidValue = true;
        return;
      }

      const valueChar = rawValue[valueIndex] as string;

      switch (maskChar) {
        case '#':
          if (!this.isNumber(valueChar)) {
            hasInvalidValue = true;
          } else {
            maskedValue += valueChar;
            valueIndex += 1;
          }
          break;
        case '%':
          if (!this.isLetter(valueChar)) {
            hasInvalidValue = true;
          } else {
            maskedValue += valueChar;
            valueIndex += 1;
          }
          break;
        case '!':
          maskedValue += valueChar;
          valueIndex += 1;
          break;

        default:
          maskedValue += maskChar;
      }
    });

    const cursorPosition = this.getCursorStart(
      maskedValue,
      previousValue,
      selectionStart,
    );

    return {
      maskedValue: this.unformat(maskedValue) ? maskedValue : '',
      cursorPosition,
    };
  };
}
